<div class="pt-10 px-10 pb-10">
  <div class="flex justify-between items-start mb-4">
    <h1 class="text-2xl font-bold">Lista de Roteiros</h1>
    <button
      type="button"
      class="bg-primary text-white py-2 px-4 rounded-lg flex items-center"
      (click)="navigateToNew()"
    >
      <mat-icon class="mr-2">add</mat-icon>
      Novo Roteiro
    </button>
  </div>

  <app-search-filter-bar
    searchPlaceholder="Buscar grupo de rotas..."
    [filters]="filters"
    (filterChange)="onFilterChange($event)"
  ></app-search-filter-bar>

  <div class="mt-4">
    <ngx-datatable
      class="material clickable-rows"
      [rows]="visitPlans"
      [columnMode]="ColumnMode.flex"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="'auto'"
      [externalPaging]="true"
      [count]="page.count"
      [offset]="page.page"
      [limit]="page.pageSize"
      (page)="onPage($event)"
      (activate)="onRowActivate($event)"
      [messages]="{
        emptyMessage: isLoading()
          ? 'Buscando resultados...'
          : 'Nenhum roteiro encontrado.'
      }"
    >
      <ngx-datatable-footer>
        <ng-template
          ngx-datatable-footer-template
          let-rowCount="rowCount"
          let-pageSize="pageSize"
          let-curPage="curPage"
        >
          <div class="flex items-center justify-between w-full px-4">
            <span class="text-sm text-gray-600">
              Mostrando {{ getStartIndex() }} a {{ getEndIndex() }} de
              {{ page.count }} resultados
            </span>
            <datatable-pager
              [pagerLeftArrowIcon]="'datatable-icon-left'"
              [pagerRightArrowIcon]="'datatable-icon-right'"
              [pagerPreviousIcon]="'datatable-icon-prev'"
              [pagerNextIcon]="'datatable-icon-skip'"
              [page]="curPage"
              [size]="pageSize"
              [count]="rowCount"
              (change)="onPage($event)"
            >
            </datatable-pager>
          </div>
        </ng-template>
      </ngx-datatable-footer>

      <ngx-datatable-column
        prop="name"
        name="Nome do Roteiro"
        [headerClass]="'text-xs'"
        [cellClass]="'cell-truncate'"
        [flexGrow]="4"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <a
            [routerLink]="getEditPath(row)"
            (click)="$event.stopPropagation()"
            class="text-sm font-semibold text-primary-dark truncate"
            [title]="row.name"
            >{{ row.name }}</a
          >
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Quantidade de Rotas"
        [headerClass]="'text-xs'"
        [flexGrow]="2"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-badge variant="blue">{{ row.routeCount }} {{ row.routeCount === 1 ? 'Rota' : 'Rotas' }}</app-badge>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Cidades Abrangidas"
        [headerClass]="'text-xs'"
        [flexGrow]="2"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-badge variant="blue">{{ row.cityCount }} {{ row.cityCount === 1 ? 'Cidade' : 'Cidades' }}</app-badge>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Quantidade de Lojas"
        [headerClass]="'text-xs'"
        [flexGrow]="2"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-badge variant="blue">{{ row.storeCount }} {{ row.storeCount === 1 ? 'Loja' : 'Lojas' }}</app-badge>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Status"
        [headerClass]="'text-xs'"
        [flexGrow]="2"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-badge [variant]="getStatusVariant(row.status)">
            {{ getStatusLabel(row.status) }}
          </app-badge>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Ações"
        [headerClass]="'text-xs'"
        [flexGrow]="2"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-nowrap pr-2 gap-2">
            <a
              [routerLink]="getEditPath(row)"
              (click)="$event.stopPropagation()"
              aria-label="Editar roteiro"
              matTooltip="Editar roteiro"
            >
              <span class="material-symbols-outlined small-icon">
                edit_square
              </span>
            </a>
            <button
              *ngxPermissionsOnly="'Permissions.VisitPlans.Delete'"
              type="button"
              (click)="confirmDelete(row); $event.stopPropagation()"
              matTooltip="Excluir roteiro"
            >
              <span class="material-symbols-outlined small-icon">
                clear
              </span>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <div class="h-24"></div>
</div>
